module.exports = {
    // uploadUrl: 'http://139.196.214.81:8082/img/gdhatch/',
    // uploadUrl: 'http://192.168.0.117:8082/img/gdhatch/',
    uploadUrl: 'https://www.guanyb.cn/img/gdhatch/',
    //比赛类型
    eventTypeList: [                            
        {label: '双人积分循环赛',value:2, name: '双人赛'},
        {label: '单人积分循环赛',value:1, name: '单人赛'},
        {label: '队式赛', value:3, name: '队式赛'},
    ],
    gradeArr: [
        { value: 0,grade: 0,},
        { value: 1,grade: 20,},
        { value: 2,grade: 40,},
        { value: 3,grade: 60,},
        { value: 4,grade: 80,},
        { value: 5,grade: 100,},
    ],
}


// WEBPACK FOOTER //
// ./src/utils/common.js